<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-if="!loading">
      <div>
        <div class="row">
          <b-form-group class="mb-3" label="Áreas de interesse">
            <multiselect
              v-model="dados.areaInteresse"
              placeholder="Selecione"
              :show-labels="false"
              label="ds_area_interesse"
              :options="optionAreaInteresse"
              :close-on-select="true"
              :multiple="true"
              @select="inserirAreaInteresse"
              @remove="removerAreaInteresse"
              track-by="cd_area_interesse"
              :max="2"
            >
              <span slot="maxElements">Limite de 2 Áreas de interesse.</span>
            </multiselect>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="mb-3" label="Regiões de interesse em atuação">
            <multiselect
              v-model="dados.regiaoInteresse"
              placeholder="Selecione"
              :show-labels="false"
              :options="optionRegiaoInteresse"
              label="nm_regiao"
              track-by="nm_regiao"
              :close-on-select="true"
              :multiple="true"
              @select="inserirRegiao"
              @remove="removerRegiao"
            />
            <b-form-checkbox
              id="todasRegioes"
              v-model="dados.todasRegioes"
              name="todasRegioes"
              :value="true"
              :unchecked-value="false"
              @change="montaTodasRegioes"
              plain
            >
              Marcar todas
            </b-form-checkbox>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="mb-3" label="Ambientes de interesse">
            <multiselect
              v-model="dados.ambienteInteresse"
              placeholder="Selecione"
              :show-labels="false"
              :options="optionAmbienteInteresse"
              :multiple="true"
              label="dsambientetrabalho"
              track-by="sqambientetrabalho"
              @select="incluirAmbiente"
              @remove="removerAmbiente"
              :max="3"
            >
              <span slot="maxElements"
                >Limite de 3 Ambientes de interesse.</span
              >
            </multiselect>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group class="mb-3" label="Conhecimentos e Habilidades">
            <multiselect
              v-model="dados.conhecimentosHabilidades"
              placeholder="Selecione"
              :show-labels="false"
              :options="optionconhecimentosHabilidades"
              label="ds_habilidade"
              track-by="sq_habilidade"
              :multiple="true"
              @select="incluirPessoaHabilidade"
              @remove="removerPessoaHabilidade"
              :max="5"
            >
              <span slot="maxElements"
                >Limite de 5 Conhecimentos e Habilidades.</span
              >
            </multiselect>
          </b-form-group>
        </div>
        <div class="row">
          <div class="mt-1 d-flex justify-content-between">
            <b-button
              class="mt-1 me-1"
              @click="navegar('ExpProfissional', false)"
              data-tooltip="Voltar"
              data-tooltip-location="bottom"
            >
              <i class="mdi mdi-arrow-left-circle font-size-15"></i>
            </b-button>
            <b-button
              variant="primary"
              class="mt-1 me-1"
              @click="navegar('idiomas', true)"
              data-tooltip="Próximo"
              data-tooltip-location="bottom"
            >
              <i class="mdi mdi-arrow-right-circle font-size-15"></i>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import Multiselect from "vue-multiselect";

// const capitalizeString = (str) => {
//   return str
//     .split(" ")
//     .map((word) => {
//       return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//     })
//     .join(" ");
// };

export default {
  components: {
    Multiselect,
  },
  async created() {
    await this.preencheLookup();
    await this.buscarPreenchido();
    this.$emit("carregarNivelPerfil");
    this.loading = false;
  },
  data() {
    return {
      dados: {
        areaInteresse: "",
        regiaoInteresse: "",
        ambienteInteresse: "",
        conhecimentosHabilidades: "",
        disponivelMudanca: "",
        todasRegioes: "",
      },
      loading: true,
      optionAreaInteresse: [],
      optionRegiaoInteresse: [],
      optionAmbienteInteresse: [],
      optionconhecimentosHabilidades: [],
      camposAreaInteresse: [
        {
          key: "DSAREAINTERESSE",
          label: "Área de interesse",
        },
        {
          key: "options",
          label: "",
        },
      ],
    };
  },
  methods: {
    async preencheLookup() {
      await Promise.all([
        this.$http.get("api/cadastroCandidato/buscarAreaInteresses"),
        this.$http.get("api/cadastroCandidato/buscarEstado"),
        this.$http.get("api/cadastroCandidato/buscarAmbiente"),
        this.$http.get("api/cadastroCandidato/buscarHabilidade"),
      ]).then(
        ([responseArea, responseEstado, responseAmbiente, responseHabi]) => {
          this.optionAreaInteresse = responseArea.data.map((item) => {
            return {
              ...item,
              ds_area_interesse: item.ds_area_interesse,
            };
          });

          this.optionRegiaoInteresse = responseEstado.data.map((item) => {
            return { ...item, nm_regiao: item.nm_regiao };
          });

          this.optionAmbienteInteresse = responseAmbiente.data.map((item) => {
            return {
              ...item,
              dsambientetrabalho: item.dsambientetrabalho,
            };
          });
          this.optionconhecimentosHabilidades = responseHabi.data;
        }
      );
    },
    async buscarPreenchido() {
      await Promise.all([
        this.$http.get("api/cadastroCandidato/buscarPessoaAreaInt"),
        this.$http.get("api/cadastroCandidato/buscarAreaAtuacao"),
        this.$http.get("api/cadastroCandidato/buscarPessoaAmbiente"),
        this.$http.get("api/cadastroCandidato/buscarPessoaHabilidade"),
      ]).then(([resAreaInt, resAreaAtuacao, resAmbiente, resHabilidade]) => {
        this.dados.areaInteresse = resAreaInt.data.map((item) => {
          return {
            ...item,
            ds_area_interesse: item.ds_area_interesse,
          };
        });

        this.dados.regiaoInteresse = resAreaAtuacao.data.map((item) => {
          return { ...item, nm_regiao: item.nm_regiao };
        });

        if (this.dados.regiaoInteresse.length == 27) {
          this.dados.todasRegioes = true;
        }

        this.dados.ambienteInteresse = resAmbiente.data.map((item) => {
          return {
            ...item,
            dsambientetrabalho: item.dsambientetrabalho,
          };
        });
        this.dados.conhecimentosHabilidades = resHabilidade.data;
      });
    },

    navegar(nomeAba, direcao) {
      this.$emit("carregarNivelPerfil");
      this.$emit("navegar", nomeAba, direcao);
    },

    inserirAreaInteresse(obj) {
      this.$http.get(
        "api/cadastroCandidato/incluirPessoaAreaInt/" + obj.cd_area_interesse
      );
    },

    removerAreaInteresse(obj) {
      this.$http.get(
        "api/cadastroCandidato/excluirAreaInteresse/" + obj.cd_area_interesse
      );
    },

    inserirRegiao(obj) {
      this.$http.get(
        "api/cadastroCandidato/incluirAreaAtuacao/" + obj.sq_regiao
      );
    },

    removerRegiao(obj) {
      this.$http
        .get("api/cadastroCandidato/excluirAreaAtuacao/" + obj.sq_regiao)
        .then(() => {
          this.dados.todasRegioes = false;
        })
        .catch(() => {});
    },

    incluirAmbiente(obj) {
      this.$http.get(
        "api/cadastroCandidato/incluirPessoaAmbiente/" + obj.sqambientetrabalho
      );
    },

    removerAmbiente(obj) {
      this.$http.get(
        "api/cadastroCandidato/excluirPessoaAmbiente/" + obj.sqambientetrabalho
      );
    },

    incluirPessoaHabilidade(obj) {
      this.$http.get(
        "api/cadastroCandidato/incluirPessoaHabilidade/" + obj.sq_habilidade
      );
    },

    removerPessoaHabilidade(obj) {
      this.$http.get(
        "api/cadastroCandidato/excluirPessoaHabilidade/" + obj.sq_habilidade
      );
    },

    montaTodasRegioes() {
      if (this.dados.todasRegioes) {
        if (this.dados.regiaoInteresse.length == 27) {
          this.$tools.alerta(
            "Todos as regiões de interese estão cadastradas",
            "info"
          );
          return;
        }
        var auxRegiao = this.dados.regiaoInteresse;
        this.dados.regiaoInteresse = this.optionRegiaoInteresse;
        this.$http
          .get("api/cadastroCandidato/incluirAreaAtuacao/0")
          .catch(() => {
            this.$tools.alerta(
              "Não foi possível cadastrar regiões de interesse",
              "error"
            );
            this.dados.regiaoInteresse = auxRegiao;
          });
      }
    },
  },
};
</script>

  <style>
.multiselect__tag {
  background: #41b883 !important;
}
</style>